export default __webpack_public_path__ + "static/media/book-whitish.6b319442.png";